export const formatCurrency = (input: number): string => {
    return input ? String(input.toFixed(2)).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'") : "0.00";
};
